import React, { Component } from "react";

const { Provider, Consumer } = React.createContext();

class InitPLProvider extends Component {
  state = {
    firstName: "",
    middleName: "",
    lastName: "",
    birthDate: "",
    birthPlace: "",
    momFirstName: "",
    momMiddleName: "",
    momLastName: "",
    gender: "",
    civilStatus: "",
    education: "",
    acrNo: "",
    sssNo: "",
    dependentsNo: "",
    citizenship: "",
    tinNo: "",
    presentHomeAddr: "",
    presentZipCode: "",
    permanentHomeAddr: "",
    permanentZipCode: "",
    homeOwnership: "",
    homeStayYrs: "",
    homeAreaCode: "",
    homePhone: "",
    mobilePhone: "",
    dayToCall: "",
    timeToCall: "",
    email: "",
    facebook: "",
    twitter: "",
    im: "",
    carsOwnedNo: "",
    spouseFirstName: "",
    spouseMiddleName: "",
    spouseLastName: "",
    spousecompanyName: "",
    spousebusinessAddr: "",
    spouseBusinessZipCode: "",
    spouseBusinessAreaCode: "",
    spouseBusinessPhone: "",
    spouseMobilePhone: "",
    spouseGrossAnnualIncome: "",
    reference1FirstName: "",
    reference1MiddleName: "",
    reference1LastName: "",
    reference1businessName: "",
    reference1bussinessAddr: "",
    reference1ZipCode: "",
    reference1BusinessAreaCode: "",
    reference1BusinessPhone: "",
    reference1MobilePhone: "",
    reference1HomeAreaCode: "",
    reference1HomePhone: "",
    reference2FirstName: "",
    reference2MiddleName: "",
    reference2LastName: "",
    reference2businessName: "",
    reference2bussinessAddr: "",
    reference2ZipCode: "",
    reference2BusinessAreaCode: "",
    reference2BusinessPhone: "",
    reference2MobilePhone: "",
    reference2HomeAreaCode: "",
    reference2HomePhone: "",

    employment: "",
    employmentOther: "",
    presentEmployerNoYrs: "",
    totalNoYrsWorking: "",
    position: "",
    positionOther: "",
    positionTitle: "",
    natureOfPresentBusiness: "",
    natureOfPresentBusinessOther: "",
    sourceOfFunds: "",
    sourceOfFundsOther: "",
    occupation: "",
    occupationOther: "",
    companyName: "",
    department: "",
    businessAddr: "",
    businessZipCode: "",
    businessAreaCode: "",
    businessPhone: "",
    businessEmail: "",
    grossAnnualIncome: "",
    existingEWDepositor: "",
    bankAccountNo: "",
    existingEWCCholder: "",
    CCNo: "",
    bank1: "",
    loanType1: "",
    monthlyAmortization1: "",
    bank2: "",
    loanType2: "",
    monthlyAmortization2: "",
    bank3: "",
    loanType3: "",
    monthlyAmortization3: "",
    activeCCOtherBanks: "",
    cardIssuer1: "",
    cardNumber1: "",
    memberSince1: "",
    creditLimit1: "",
    cardIssuer2: "",
    cardNumber2: "",
    memberSince2: "",
    creditLimit2: "",
    cardIssuer3: "",
    cardNumber3: "",
    memberSince3: "",
    creditLimit3: "",
    loanPurpose: "",
    loanPurposeOther: "",
    desiredLoanAmount: "",
    myPreferredPaymentTenor: "",
    loanLowerAmount: "",
    ewOtherProducts: true,
    agreeRadio: "",
    chkPermAddSameWithHomeAdd: "",
  };

  render() {
    return (
      <Provider
        value={{
          firstName: this.state.firstName,
          middleName: this.state.middleName,
          lastName: this.state.lastName,
          birthDate: this.state.birthDate,
          birthPlace: this.state.birthPlace,
          momFirstName: this.state.momFirstName,
          momMiddleName: this.state.momMiddleName,
          momLastName: this.state.momLastName,
          gender: this.state.gender,
          civilStatus: this.state.civilStatus,
          education: this.state.education,
          acrNo: this.state.acrNo,
          sssNo: this.state.sssNo,
          dependentsNo: this.state.dependentsNo,
          citizenship: this.state.citizenship,
          tinNo: this.state.tinNo,
          presentHomeAddr: this.state.presentHomeAddr,
          presentZipCode: this.state.presentZipCode,
          permanentHomeAddr: this.state.permanentHomeAddr,
          permanentZipCode: this.state.permanentZipCode,
          homeOwnership: this.state.homeOwnership,
          homeStayYrs: this.state.homeStayYrs,
          homeAreaCode: this.state.homeAreaCode,
          homePhone: this.state.homePhone,
          mobilePhone: this.state.mobilePhone,
          dayToCall: this.state.dayToCall,
          timeToCall: this.state.timeToCall,
          email: this.state.email,
          facebook: this.state.facebook,
          twitter: this.state.twitter,
          im: this.state.im,
          carsOwnedNo: this.state.carsOwnedNo,
          spouseFirstName: this.state.spouseFirstName,
          spouseMiddleName: this.state.spouseMiddleName,
          spouseLastName: this.state.spouseLastName,
          spousecompanyName: this.state.spousecompanyName,
          spousebusinessAddr: this.state.spouseBusinessAddr,
          spouseBusinessZipCode: this.state.spouseBusinessZipCode,
          spouseBusinessAreaCode: this.state.spouseBusinessAreaCode,
          spouseBusinessPhone: this.state.spouseBusinessPhone,
          spouseMobilePhone: this.state.spouseMobilePhone,
          spouseGrossAnnualIncome: this.state.spouseGrossAnnualIncome,
          reference1FirstName: this.state.reference1FirstName,
          reference1MiddleName: this.state.reference1MiddleName,
          reference1LastName: this.state.reference1LastName,
          reference1businessName: this.state.reference1businessName,
          reference1bussinessAddr: this.state.reference1bussinessAddr,
          reference1ZipCode: this.state.reference1ZipCode,
          reference1BusinessPhone: this.state.reference1BusinessPhone,
          reference1BusinessAreaCode: this.state.reference1BusinessAreaCode,
          reference1MobilePhone: this.state.reference1MobilePhone,
          reference1HomeAreaCode: this.state.reference1HomeAreaCode,
          reference1HomePhone: this.state.reference1HomePhone,
          reference2FirstName: this.state.reference2FirstName,
          reference2MiddleName: this.state.reference2MiddleName,
          reference2LastName: this.state.reference2LastName,
          reference2businessName: this.state.reference2businessName,
          reference2bussinessAddr: this.state.reference2bussinessAddr,
          reference2ZipCode: this.state.reference2ZipCode,
          reference2BusinessPhone: this.state.reference2BusinessPhone,
          reference2BusinessAreaCode: this.state.reference2BusinessAreaCode,
          reference2MobilePhone: this.state.reference2MobilePhone,
          reference2HomeAreaCode: this.state.reference2HomeAreaCode,
          reference2HomePhone: this.state.reference2HomePhone,
          employment: this.state.employment,
          employmentOther: this.state.employmentOther,
          presentEmployerNoYrs: this.state.presentEmployerNoYrs,
          totalNoYrsWorking: this.state.totalNoYrsWorking,
          position: this.state.position,
          positionOther: this.state.positionOther,
          positionTitle: this.state.positionTitle,
          natureOfPresentBusiness: this.state.natureOfPresentBusiness,
          natureOfPresentBusinessOther: this.state.natureOfPresentBusinessOther,
          sourceOfFunds: this.state.sourceOfFunds,
          sourceOfFundsOther: this.state.sourceOfFundsOther,
          occupation: this.state.occupation,
          occupationOther: this.state.occupationOther,
          companyName: this.state.companyName,
          department: this.state.department,
          businessAddr: this.state.businessAddr,
          businessZipCode: this.state.businessZipCode,
          businessAreaCode: this.state.businessAreaCode,
          businessPhone: this.state.businessPhone,
          businessEmail: this.state.businessEmail,
          grossAnnualIncome: this.state.grossAnnualIncome,
          existingEWDepositor: this.state.existingEWDepositor,
          bankAccountNo: this.state.bankAccountNo,
          existingEWCCholder: this.state.existingEWCCholder,
          CCNo: this.state.CCNo,
          bank1: this.state.bank1,
          loanType1: this.state.loanType1,
          monthlyAmortization1: this.state.monthlyAmortization1,
          bank2: this.state.bank2,
          loanType2: this.state.loanType2,
          monthlyAmortization2: this.state.monthlyAmortization2,
          bank3: this.state.bank3,
          loanType3: this.state.loanType3,
          monthlyAmortization3: this.state.monthlyAmortization3,
          activeCCOtherBanks: this.state.activeCCOtherBanks,

          cardIssuer1: this.state.cardIssuer1,
          cardNumber1: this.state.cardNumber1,
          memberSince1: this.state.memberSince1,
          creditLimit1: this.state.creditLimit1,
          cardIssuer2: this.state.cardIssuer2,
          cardNumber2: this.state.cardNumber2,
          memberSince2: this.state.memberSince2,
          creditLimit2: this.state.creditLimit2,
          cardIssuer3: this.state.cardIssuer3,
          cardNumber3: this.state.cardNumber3,
          memberSince3: this.state.memberSince3,
          creditLimit3: this.state.creditLimit3,
          loanPurpose: this.state.loanPurpose,
          loanPurposeOther: this.state.loanPurposeOther,
          desiredLoanAmount: this.state.desiredLoanAmount,
          myPreferredPaymentTenor: this.state.myPreferredPaymentTenor,
          loanLowerAmount: this.state.loanLowerAmount,
          ewOtherProducts: this.state.ewOtherProducts,
          agreeRadio: this.state.agreeRadio,
          chkPermAddSameWithHomeAdd: this.state.chkPermAddSameWithHomeAdd,

          handleInputChange: event => {
            const target = event.target;
            const value = target.value;
            const fname = target.name;

            this.setState({
              [fname]: value
            });
          },
          updateState: (sname, inval) => {
            this.setState({
              [sname]: inval
            });
          },
          handleEdit: step => () => {
            this.setState(prevState => ({
              activeStep: prevState.activeStep - step
            }));
            window.scrollTo(0, 0);
          },
          resetForm: () => {
            this.setState({
              firstName: "",
              middleName: "",
              lastName: "",
              birthDate: "",
              birthPlace: "",
              momFirstName: "",
              momMiddleName: "",
              momLastName: "",
              gender: "",
              civilStatus: "",
              education: "",
              acrNo: "",
              sssNo: "",
              dependentsNo: "",
              citizenship: "",
              tinNo: "",
              presentHomeAddr: "",
              presentZipCode: "",
              permanentHomeAddr: "",
              permanentZipCode: "",
              homeOwnership: "",
              homeStayYrs: "",
              homeAreaCode: "",
              homePhone: "",
              mobilePhone: "",
              dayToCall: "",
              timeToCall: "",
              email: "",
              facebook: "",
              twitter: "",
              im: "",
              carsOwnedNo: "",
              spouseFirstName: "",
              spouseMiddleName: "",
              spouseLastName: "",
              spousecompanyName: "",
              spousebusinessAddr: "",
              spouseBusinessZipCode: "",
              spouseBusinessAreaCode: "",
              spouseBusinessPhone: "",
              spouseMobilePhone: "",
              spouseGrossAnnualIncome: "",
              reference1FirstName: "",
              reference1MiddleName: "",
              reference1LastName: "",
              reference1businessName: "",
              reference1bussinessAddr: "",
              reference1ZipCode: "",
              reference1BusinessPhone: "",
              reference1BusinessAreaCode: "",
              reference1MobilePhone: "",
              reference1HomeAreaCode: "",
              reference1HomePhone: "",
              reference2FirstName: "",
              reference2MiddleName: "",
              reference2LastName: "",
              reference2businessName: "",
              reference2bussinessAddr: "",
              reference2ZipCode: "",
              reference2BusinessAreaCode: "",
              reference2BusinessPhone: "",
              reference2MobilePhone: "",
              reference2HomeAreaCode: "",
              reference2HomePhone: "",
              employment: "",
              employmentOther: "",
              presentEmployerNoYrs: "",
              totalNoYrsWorking: "",
              position: "",
              positionOther: "",
              positionTitle: "",
              natureOfPresentBusiness: "",
              natureOfPresentBusinessOther: "",
              sourceOfFunds: "",
              sourceOfFundsOther: "",
              occupation: "",
              occupationOther: "",
              companyName: "",
              department: "",
              businessAddr: "",
              businessZipCode: "",
              businessAreaCode: "",
              businessPhone: "",
              businessEmail: "",
              grossAnnualIncome: "",
              existingEWDepositor: "",
              bankAccountNo: "",
              existingEWCCholder: "",
              CCNo: "",
              bank1: "",
              loanType1: "",
              monthlyAmortization1: "",
              bank2: "",
              loanType2: "",
              monthlyAmortization2: "",
              bank3: "",
              loanType3: "",
              monthlyAmortization3: "",
              activeCCOtherBanks: "",

              cardIssuer1: "",
              cardNumber1: "",
              memberSince1: "",
              creditLimit1: "",
              cardIssuer2: "",
              cardNumber2: "",
              memberSince2: "",
              creditLimit2: "",
              cardIssuer3: "",
              cardNumber3: "",
              memberSince3: "",
              creditLimit3: "",
              loanPurpose: "",
              loanPurposeOther: "",
              desiredLoanAmount: "",
              myPreferredPaymentTenor: "",
              loanLowerAmount: "",
              ewOtherProducts: true,
              agreeRadio: "",
              chkPermAddSameWithHomeAdd: "",
            });
          }
        }}
      >
        {this.props.children}
      </Provider>
    );
  }
}

export { InitPLProvider, Consumer };
